/**
 * VIB-1288: rent filterpredikat for avsluttet-visningens år+måned-filter.
 * Utledet fra `completed_at` (ISO-dato-streng eller null).
 *
 * - Kun år satt (`month` null/undefined) → sammenlign ÅÅÅÅ (samme oppførsel som VIB-1189).
 * - År + måned satt → sammenlign ÅÅÅÅ-MM.
 * - `completedAt` null/undefined → matcher aldri (prosjektet mangler avsluttet-dato).
 */
export function matchesCompletedPeriod(
  completedAt: string | null | undefined,
  year: number,
  month?: number | null,
): boolean {
  if (!completedAt) return false;
  const s = String(completedAt);
  if (month) {
    const target = `${year}-${String(month).padStart(2, "0")}`;
    return s.slice(0, 7) === target;
  }
  return s.slice(0, 4) === String(year);
}

/** Norske månedsnavn, 1-indeksert (index 0 = januar = måned 1). */
export const MONTH_NAMES_NB = [
  "Januar",
  "Februar",
  "Mars",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Desember",
] as const;
